

const NormalEventMapCard = ({data}) => {
  return (
    <div className="normal-event-map-card">
    <img src={data?.photos?.[0]} height={60} width={60} alt="event"/>
    </div>
  )
}

export default NormalEventMapCard